import { render, staticRenderFns } from "./CloHeaderSapsucker.vue?vue&type=template&id=636ad5ea&"
import script from "./CloHeaderSapsucker.vue?vue&type=script&lang=js&"
export * from "./CloHeaderSapsucker.vue?vue&type=script&lang=js&"
import style0 from "./CloHeaderSapsucker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports